import CityPageTemplate from "../city-template/CityPageTemplate";
import { oronoConfig } from "./data";

export default function OronoPage() {
  return <CityPageTemplate config={oronoConfig} />;
}